var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicFieldsRenderer',{staticClass:"resource-preview",attrs:{"fields":_vm.resourcePreviewFields,"questions":_vm.resourcePreviewQuestions,"document-value":_vm.value,"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }